import { deleteChatConfiguration, generateChatConfigurationKey } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { ChangeEvent, ChangeEventType, DeleteBlockEvent, PortalBlockType } from '@nx-frontend/shared/types';

interface ProcessDeleteChatEventsProps {
  orgId: string;
  workspaceId: string;
  portalId: string;
  sessionId: string | null;
  history: ChangeEvent[];
}

export const processDeleteChatEvents = ({
  orgId,
  workspaceId,
  portalId,
  sessionId,
  history,
}: ProcessDeleteChatEventsProps) => {
  const deleteChatEvents: DeleteBlockEvent[] = history.reduce((acc, event) => {
    if (event.type === ChangeEventType.DELETE_BLOCK && event.oldValue.type === PortalBlockType.CHAT) {
      acc.push(event);
    }
    return acc;
  }, <DeleteBlockEvent[]>[]);

  deleteChatEvents.map((event) => {
    const configKey = generateChatConfigurationKey({
      orgId,
      workspaceId,
      portalId,
      widgetId: event.oldValue.id,
    });
    // return deleteChatConfiguration(env.chatApiUrl, configKey, sessionId ?? '', orgId);
    return deleteChatConfiguration(generalEnv.chatApiUrl, configKey, sessionId ?? '', orgId);
  });

  return;
};

export const reduceHistory = (history: ChangeEvent[]): ChangeEvent[] => {
  const reducedHistory = history.reduce<ChangeEvent[]>((acc, event) => {
    const [prev] = acc.slice(-1);

    if (prev == null || event.collectId !== prev.collectId || event.type !== prev.type) {
      acc.push(event);
      return acc;
    }

    if (event.type === ChangeEventType.UPDATE_THEME_SETTINGS && event.type === prev.type) {
      acc.pop();
      acc.push({ ...event, oldValue: prev.oldValue });
      return acc;
    }

    if (
      event.type === ChangeEventType.UPDATE_BLOCK &&
      event.type === prev.type &&
      event.newValue.id === prev.oldValue.id
    ) {
      acc.pop();
      acc.push({ ...event, oldValue: prev.oldValue });
      return acc;
    }

    acc.push(event);
    return acc;
  }, []);

  return reducedHistory;
};
